// Live pub/sub for "which card is the cursor over right now".
//
// Distinct from the streamer-drawer's sticky `focusedPreviewCard`
// (GameBoard.jsx ~L808), which intentionally keeps the last useful
// face-up card pinned. This bus is the opposite: it reflects the
// instantaneous hover state. Null while the cursor is over empty
// playmat. So consumers like CardAltZoomOverlay can hide as soon
// as the cursor leaves a card.
//
// Producers: GameBoard wires its 3D mesh-hover (handleMouseMove) and
// DOM hand-hover (componentDidUpdate) into setHoveredCard. Any future
// hover surface (replay viewer, controller aim, etc.) can call it too
// without GameBoard needing to know about the consumer.
//
// The bus stores the raw card instance. Face-down filtering and any
// other policy lives in the consumer, so non-zoom subscribers stay
// free to see the underlying instance.

let currentCard = null;
const subscribers = new Set();

function notify() {
  for (const cb of subscribers) cb(currentCard);
}

export function setHoveredCard(card) {
  const next = card || null;
  if (currentCard === next) return;
  currentCard = next;
  notify();
}

export function getHoveredCard() {
  return currentCard;
}

export function subscribeHoveredCard(cb) {
  subscribers.add(cb);
  cb(currentCard);
  return () => {
    subscribers.delete(cb);
  };
}

export function clearHoveredCard() {
  setHoveredCard(null);
}
